











































import transactionType from '@/store/types/transaction';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'TransactionToLiquidateModal',
  props: {
    viewModal: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    reference: '',
  }),
  computed: {
    ...mapGetters({
      getTransaction: `transactionModule/${transactionType.getters.GET_FLAGGED_TRANSACTION}`,
    }),
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean) {
        this.$emit('update:viewModal', value);
      },
    },
  },
  methods: {
    firstFormSubmit: () => {},
  },
});
